/**
 * Can this browser do push at all, and what has the user already answered?
 *
 * Pure and guarded, like `pwa/platform.ts` — jsdom has none of these APIs, so every check is
 * behind a `typeof` test rather than assuming the global exists.
 */

export function isPushSupported(): boolean {
  if (typeof navigator === "undefined" || typeof window === "undefined") return false;
  return (
    "serviceWorker" in navigator &&
    typeof window.PushManager !== "undefined" &&
    typeof window.Notification !== "undefined"
  );
}

/** `"unsupported"` rather than a throw, so callers can branch on one value. */
export function readPermission(): NotificationPermission | "unsupported" {
  if (!isPushSupported()) return "unsupported";
  return window.Notification.permission;
}

/**
 * Ask the browser. Must be called from a user gesture: iOS refuses otherwise, and Chrome
 * penalises an origin that prompts on load.
 *
 * A "denied" origin resolves immediately, with no dialog and no way back — only the user can
 * reset it in site settings. That is why nothing in this app ever re-prompts.
 */
export async function requestPushPermission(): Promise<NotificationPermission | "unsupported"> {
  if (!isPushSupported()) return "unsupported";
  return window.Notification.requestPermission();
}
